var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMindFaster = function SvgMindFaster(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2FBC44",
    stroke: "#2FBC44",
    d: "M20.43 7.851q-.216.008-.427.008c-3.534 0-5.086-1.59-5.1-1.602l-.382-.425a.7.7 0 0 0-1.04 0l-.39.432.003-.003c-.001-.001-1.638 1.725-5.525 1.59l-.545-.018a.7.7 0 0 0-.724.7v6.809c0 1.16.193 2.638 1.241 4.147 1.042 1.5 2.876 2.955 6.013 4.188l.19.074a.7.7 0 0 0 .512 0l.19-.074c3.137-1.233 4.971-2.688 6.013-4.187 1.048-1.51 1.241-2.988 1.241-4.148v-6.81a.7.7 0 0 0-.724-.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m10.57 15 2.334 2.8 4.666-5.6"
  })));
};
export default SvgMindFaster;